import React from 'react';

import './RadioButton.css';

const RadioButton = (props) => {
  const { className } = props;

  const attributes = {
    ...props,
    type: 'radio',
    className: `form-input-radio ${className || ''}`,
    'iso-latin-only': '',
  };

  return (
    <div className="form-input-radio-parent">
      <input {...attributes} />
      <div className="form-input-radio-icon" />
    </div>
  );
};

export default RadioButton;
